/** Shape of an error returned by the API. */
export interface ApiErrorBody {
  error: {
    code: string
    message: string
    /** Optional field-level validation details. */
    fields?: Record<string, string>
  }
}

/** A paginated list envelope. */
export interface Paginated<T> {
  items: T[]
  total: number
  page: number
  pageSize: number
}

export class ApiError extends Error {
  readonly status: number
  readonly code: string
  readonly fields?: Record<string, string>

  constructor(status: number, body: ApiErrorBody['error']) {
    super(body.message)
    this.name = 'ApiError'
    this.status = status
    this.code = body.code
    this.fields = body.fields
  }
}
